'use client'
import { ArrowRight } from "@phosphor-icons/react";

export const CtaButton = ({text}) => {
  return (
    <div>
      <button className="bg-[#0D6FEA] hover:bg-[#08448F] text-white text-[16px] px-[16px] py-[8px] rounded-[4px] flex gap-[8px] uppercase justify-center border border-[#0D6FEA] hover:border-[#08448F] font-[400] w-full md:w-auto cursor-pointer">
        {text}{" "}
        <span>
          <ArrowRight size={24} />
        </span>
      </button>
    </div>
  );
};

export const CtaButton2 = ({text}) => {
  return (
    <div>
    <a href="#batches">
      <button className="bg-[#ffffff] text-[#0D6FEA] hover:text-[#08448F] text-[16px] px-[16px] py-[8px] rounded-[4px] flex gap-[8px] uppercase justify-center border border-[#0D6FEA] hover:border-[#08448F] font-[400] w-full md:w-auto cursor-pointer">
        {text}
      </button>
    </a>
    </div>
  );
};
